import { render, staticRenderFns } from "./create-quotation.vue?vue&type=template&id=3dd96356&scoped=true"
import script from "./create-quotation.vue?vue&type=script&lang=js"
export * from "./create-quotation.vue?vue&type=script&lang=js"
import style0 from "./create-quotation.vue?vue&type=style&index=0&id=3dd96356&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd96356",
  null
  
)

export default component.exports